<script lang="ts">
  import type { Attachment } from "svelte/attachments";
  import Toast from "./Toast.svelte";
  import { dismissToast, toasts } from "./toast.svelte.ts";

  const raised: Attachment<HTMLElement> = (node) => {
    const count = toasts().length;
    if (node.matches(":popover-open")) node.hidePopover();
    if (count > 0) node.showPopover();
  };
</script>

<div
  popover="manual"
  role="status"
  aria-live="polite"
  {@attach raised}
  class="inset-auto right-4 bottom-4 m-0 flex flex-col items-end gap-2 overflow-visible border-0 bg-transparent p-0 max-md:left-4 max-md:items-stretch"
>
  {#each toasts() as entry (entry.id)}
    <Toast
      kind={entry.kind}
      message={entry.message}
      signIn={entry.signIn}
      action={entry.action === null
        ? null
        : {
            label: entry.action.label,
            run: () => {
              entry.action?.run();
              dismissToast(entry.id);
            },
          }}
      ondismiss={() => dismissToast(entry.id)}
    />
  {/each}
</div>
